// Cross-tab BroadcastChannel names, single source of truth.
// See .claude/context/composition-topology.md for why, and what's still to come.
export const CHANNELS = {
  assistant: 'magic-apron-assistant',
  newMessage: 'magic-apron-new-message',
};

export const createBroadcastChannel = (name) => new BroadcastChannel(name);
